import { z } from "zod";

/**
 * An MCP tool's optional `outputSchema`: a JSON Schema for its structured result,
 * whose root is an object. Kept verbatim beyond the root `type`, for the same
 * reason as {@link McpToolInputSchemaSchema}.
 */
export const McpToolOutputSchemaSchema = z.looseObject({
  type: z.literal("object")
});

export type McpToolOutputSchema = z.infer<typeof McpToolOutputSchemaSchema>;
